<template>
  <v-card class="d-flex flex-column">
    <v-overlay
      absolute
      opacity="0.8"
      :value="!hasData"
    >
      <span class="text-bold">
        Facebook not linked
      </span>
    </v-overlay>
    <v-card-title class="font-weight-semibold">
      Audience locale language
    </v-card-title>
    <v-card-subtitle>
      {{ subTitle }}
    </v-card-subtitle>

    <v-card-text class="font-weight-semibold text-center text--primary">
      <vue-apex-charts
        :options="chartOptions"
        :series="chartSeries"
      ></vue-apex-charts>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  components: { VueApexCharts },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const audienceLocalData = props?.data;
    const chartOptions = {

      chart: {
        type: 'pie',
        height: 100,
        toolbar: { show: false },
      },
      labels: (audienceLocalData?.data || [{ name: 'no data' }]).map((item) => item.name),
      fill: {
        opacity: 1,
      },
      stroke: {
        width: 1,
        colors: undefined,
      },
      yaxis: {
        show: false,
      },
      legend: {
        position: 'left',
      },

    };
    const chartSeries = (audienceLocalData?.data || [{ percentage: 100 }]).map((item) => item.percentage);

    return {
      chartOptions,
      chartSeries,
      subTitle: audienceLocalData?.description,
      hasData: audienceLocalData,
    };
  },
};
</script>
